import React from 'react';
import { AboutUsPage } from './pages/AboutUsPage';
export function App() {
  return <AboutUsPage data-id="element-0" />;
}